import { useEffect } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { useFormikContext, useField } from 'formik'
import { isEmpty, isArray } from 'lodash-es'

// Components
import VirtualizedSelect from '@/components/common/VirtualizedSelect'

// Style
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

// PropTypes
export const propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  isMulti: PropTypes.bool,
  placeholder: PropTypes.string,
}

// DefaultProps
export const defaultProps = {
  options: [],
  onChange: () => {},
  isMulti: false,
}

function VirtualizedSelectField(props) {
  const { className, options, onChange: onChangeProps, isMulti, ...restProps } = props
  const [field] = useField(props)
  const { setFieldValue } = useFormikContext()

  const isValueEmpty = isEmpty(options) || !field.value

  const defaultValue = options.filter((option) => {
    const isArrayValue = isArray(field?.value)

    if (isArrayValue) {
      return field.value.includes(option.value)
    } else {
      return field.value === option.value
    }
  })

  const value = isValueEmpty
    ? []
    : options.filter((option) => {
        const isArrayValue = isArray(field?.value)

        if (isArrayValue) {
          return field.value.includes(option.value)
        } else {
          return field.value === option.value
        }
      })

  useEffect(() => {
    // 如果有 defaultValue，didMount 時先 setFieldValue
    if (!isEmpty(options) && !isEmpty(field.value)) {
      if (isMulti) {
        setFieldValue(
          field.name,
          defaultValue.map((item) => item.value),
        )
      } else {
        setFieldValue(field.name, defaultValue[0]?.value || '')
      }
    }
  }, [])

  const handleOptionChange = (option) => {
    if (isMulti) {
      onChangeProps(
        option.map((item) => item.value),
        options,
      )

      setFieldValue(
        field.name,
        option.map((item) => item.value),
      )
    } else {
      onChangeProps(option || '', options)

      setFieldValue(field.name, option?.value || '')
    }
  }

  return (
    <div className={cx('select-wrapper', className)} data-has-value={!isValueEmpty}>
      <VirtualizedSelect
        handleOptionChange={handleOptionChange}
        options={options}
        isMulti={isMulti}
        value={value}
        defaultValue={defaultValue}
        {...restProps}
      />
    </div>
  )
}

VirtualizedSelectField.propTypes = propTypes
VirtualizedSelectField.defaultProps = defaultProps

export default VirtualizedSelectField
